import { View } from "@react-pdf/renderer";
import { ResumePDFText } from "components/Resume/ResumePDF/common";
import { styles, spacing } from "components/Resume/ResumePDF/styles";
import { TemplateFivePDFSection, TemplateFivePDFSectionWithSubsections } from "./common";

export const Summary = ({
  heading,
  summary,
  themeColor,
}: {
  heading: string;
  summary: string;
  themeColor: string;
}) => {
  return (
    <TemplateFivePDFSectionWithSubsections themeColor={themeColor} heading={heading}>
      <View wrap={false}>
        {summary && (
          <ResumePDFText style={{ lineHeight: "1.3" }}>
            {summary}
          </ResumePDFText>
        )}
      </View>
    </TemplateFivePDFSectionWithSubsections>
  );
};
